function getStep1Module1State(state) {
  return {
    propertyTypes: state.step1Module1.propertyTypes,
    propertySubTypes: state.step1Module1.propertySubTypes,
    propertyTypesLoading: state.step1Module1.propertyTypesLoading,
    propertySubTypesLoading: state.step1Module1.propertySubTypesLoading,
    propertyTypesError: state.step1Module1.propertyTypesError,
    propertySubTypesError: state.step1Module1.propertySubTypesError,
    formValues: {
      selectedPropertyTypeId: state.step1Module1.formValues.selectedPropertyTypeId,
      selectedPropertySubTypeId: state.step1Module1.formValues.selectedPropertySubTypeId,
      selectedOperationTypeId: state.step1Module1.formValues.selectedOperationTypeId
    },
    originalValues: {
      selectedPropertyTypeId: state.step1Module1.originalValues.propertyType,
      selectedPropertySubTypeId: state.step1Module1.originalValues.propertySubType,
      selectedOperationTypeId: state.step1Module1.originalValues.operationType
    },
    hasValues: state.step1Module1.hasValues,
    isCompleted: state.step1Module1.isCompleted,
    disabledBranch: state.step1Module1.disabledBranch,
    redirectFromAppraisal: state.step1Module1.redirectFromAppraisal,
    postingStatuses: state.step1Module1.postingStatuses
  };
}

function getInfoEvents(state) {
  return {
    postingStatuses: state.step1Module1.postingStatuses,
    operationTypeId: state.step1Module1.formValues.selectedOperationTypeId,
    propertyTypeId: state.step1Module1.formValues.selectedPropertyTypeId,
    subPropertyTypeId: state.step1Module1.formValues.selectedPropertySubTypeId,
    propertyTypes: state.step1Module1.propertyTypes,
    propertySubTypes: state.step1Module1.propertySubTypes
  };
}

export { getStep1Module1State, getInfoEvents };
